import Home from './';

const routesHome = [
    {
      path: '/',
      component: Home,
    },
    {
      path: '/home',
      component: Home,
    }
  ];
  
export default routesHome;